export default {
  pocketHooks: {
    useAccountSettings: {
      accountMenu: {
        accountSettings: '_TODO: Account Settings',
        contactPreferences: '_TODO: Contact Preferences',
        myDetails: '_TODO: My Details',
        mySubscriptions: '_TODO: My Subscriptions',
        overview: '_TODO: Overview',
        signOut: '_TODO: Sign out'
      },
      accountNavOptions: {
        label: '_TODO: My Account'
      }
    }
  }
};